import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';

const TermsAndConditions = props => {
  const [formData, setFormData] = useState({
    agree1: false,
    agree2: false
  });
  const onDataChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  const onSubmit = () => {
    if (formData['agree1'] && formData['agree2']) {
      if (props.location.state) {
        props.history.push({
          pathname: '/testdrive',
          state: { data: props.location.state.data }
        });
      }
    }
  };

  const disabled =
    formData && formData['agree1'] && formData['agree2'] ? false : true;

  return (
    <Fragment>
      {formData ? (
        <div>
          <br />
          <div align='center'>
            <font size='3' face='arial'>
              <u>
                <b>AGREEMENT OF TEST DRIVE PROCEDURES / INDEMNITY FORM</b>
              </u>
            </font>
          </div>
          <br />
          <p align='justify'>
            <font face='arial' size='2'>
              I (the "Customer") agree and undertake to Motor Image Enterprises
              Pte Ltd ("MIE") that in consideration of MIE allowing me to test
              drive/drive ("test drive") its car, I will observe, and agree to
              abide and be bound by, the following at all times:
            </font>
          </p>
          <ol>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Comply with all instructions given to me by MIE staff
                  regarding the test drive and I will hand over control of the
                  car to MIE staff immediately upon request.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Test drive only along the routes shown below and/ or such
                  other area(s) as MIE may designate and at all times exercise
                  due care and caution.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Comply with all posted road speed limits during the test drive
                  or drive at lower speed limits as may be necessitated by road
                  and/or weather conditions.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Comply with all posted road speed limits during the test drive
                  or drive at lower speed limits as may be necessitated by road
                  and/or weather conditions.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Take due care of the car under my control and be responsible
                  for any loss or damage to it and/or to other property and/or
                  injury or death to third parties including the car's other
                  occupants.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Be personally liable for all traffic violations during the
                  test drive.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  Waive all claims against MIE and/or indemnify and keep MIE,
                  its employees, agents and others indemnified at all times on
                  demand from and against all actions, claims, costs, expenses
                  and/or demands in respect of injury and/or loss of life, loss
                  and/or damage to property (including the test drive car),
                  howsoever caused arising out of or in connection with the test
                  drive notwithstanding that the same may have been contributed
                  to or occasioned by the negligence of MIE, its employees,
                  agents and/or others.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  This agreement is governed by Singapore law and I agree to
                  submit to the non-exclusive jurisdiction of the Singapore
                  courts.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  I hereby acknowledge and consent to the collection, retention,
                  use and disclosure within Motor Image Enterprises Pte Ltd and
                  its related and associated companies ("MIE") of the Driving
                  License/NRIC information that I have provided to MIE for the
                  purpose of verification and insurance coverage.
                </font>
              </p>
            </li>
            <li>
              <p align='justify'>
                <font face='arial' size='2'>
                  I further consent to being contacted using my personal
                  information by email/ telephone/sms in relation to customer
                  feedback, promotions, events and the purchase of motor
                  vehicles.
                </font>
              </p>
            </li>
          </ol>
          <p>
            <input
              type='checkbox'
              name='agree1'
              onChange={e => onDataChange(e)}
            />
            <font size='2' face='arial'>
              {' '}
              I agree to MIE’s Test Drive Procedures.
            </font>
            <br />
            <input
              type='checkbox'
              name='agree2'
              onChange={e => onDataChange(e)}
            />
            <font size='2' face='arial'>
              {' '}
              I agree to provide details from MyInfo to facilitate the test
              drive.
            </font>
          </p>
          <p>
            <input
              type='submit'
              className='btn btn-primary'
              value='Continue'
              disabled={disabled}
              onClick={onSubmit}
            />
          </p>
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  data: state.data
});

export default connect(mapStateToProps)(TermsAndConditions);
